import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/* eslint-disable camelcase */
import axios from "axios"; //Limitless

import ClientContext from "../../../common/utils/client-context/ClientContext";
import { log as logger } from "../../../common/utils/Logging";
import { createPublicAPIRequest } from "../../../common/utils/PublicAPIUtils";
import { handleAPIFailure } from "../../../common/utils/api-log-helper/APILogHelper";
import { MESSAGE_STATE_NEW, MESSAGE_STATE_CLOSED, MESSAGE_STATE_REPORTED } from "../../utils/customer-message-state-engine/CustomerMessageStateConstants";
/**
 * A customer has a question, let's submit it to the platform, via le intgration module
 *
 * @param {object} customer
 * @param {function} callback
 */

export var createCustomerMessage = function createCustomerMessage(customer, callback) {
  var log = logger.getLogger("CustomerMessageAPI createCustomerMessage");
  var name = customer.name,
      email = customer.email,
      question = customer.question,
      mobileNumber = customer.mobileNumber;
  log.debug("Creating message for ".concat(name, ", ").concat(email, ", ").concat(question));
  var trimmedName = name.trim();
  var splitNameArr = trimmedName.split(" ");
  var message = {
    groupName: ClientContext._groupName,
    body: question.trim(),
    customerEmail: email,
    customerFirstName: splitNameArr[0],
    customerLastNameInitial: splitNameArr[1] ? splitNameArr[1] : "",
    tenantChannel: "llm",
    tenantMsgType: ClientContext._tenantMsgType,
    tenantMsgId: ClientContext._tenantMsgId,
    tenantProp1: ClientContext._msgProp1,
    tenantProp2: ClientContext._msgProp2,
    tenantProp3: ClientContext._msgProp3,
    tenantProp4: ClientContext._msgProp4,
    tenantProp5: ClientContext._msgProp5,
    tenantProp6: ClientContext._msgProp6,
    tenantProp7: ClientContext._msgProp7,
    tenantProp8: ClientContext._msgProp8,
    tenantProp9: ClientContext._msgProp9,
    tenantMsgSource: ClientContext._tenantMsgSource,
    clientAppVersion: process.env.REACT_APP_VERSION
  };

  if (mobileNumber) {
    message.customerPhone = mobileNumber.replace(new RegExp(" ", "g"), "");
  }

  if (ClientContext._extraInfo) {
    message.customerData = ClientContext._extraInfo;
  }

  var apiConfig = createPublicAPIRequest("post", "messages", null, message, null, true); //Ajax call URL, payload, config

  axios(apiConfig).then(function (response) {
    // Platform Give "REJ - Rejected" or "ACC - accepted" while creating the message
    if (response.data.processCode === "REJ") {
      callback({
        hasError: true
      });
    } else {
      //merge our message object with fields from API
      Object.assign(message, response.data);
      Object.assign(message, {
        messageId: message.msgId
      });
      Reflect.deleteProperty(message, "msgId");
      message.footerState = MESSAGE_STATE_NEW;
      callback(message);
    }
  }).catch(function (error) {
    handleAPIFailure(error, "CustomerMessageAPI createCustomerMessage");
    callback({
      hasError: true
    });
  });
};
/**
 * Calling the GET message API to retrieve a message with all dialogues
 *
 * @param {string} messageId
 * @param {function} callback
 */

export var fetchCustomerMessage = function fetchCustomerMessage(messageId, accessKey, callback) {
  var log = logger.getLogger("CustomerMessageAPI fetchCustomerMessage");
  var additionalHeaders = {
    "App-Name": process.env.REACT_APP_NAME.toLowerCase(),
    "App-Type": "web",
    "App-Version": process.env.REACT_APP_VERSION
  };
  var fetchRequestParams = {
    readonly: false,
    requester: "customer",
    access_key: accessKey
  };
  var apiConfig = createPublicAPIRequest("put", "messages/".concat(messageId, "/read"), fetchRequestParams, null, additionalHeaders);
  axios(apiConfig).then(function (response) {
    var message = response.data;
    log.info("Read completed %o", response);

    if (message) {
      //we never get this back from the read API
      message.accessKey = accessKey;
      callback(message);
    } else {
      callback({
        hasError: true
      });
    }
  }).catch(function (error) {
    handleAPIFailure(error, "CustomerMessageAPI fetchCustomerMessage");
    callback({
      hasError: true
    });
  });
};

var mutateCustomerMessage = function mutateCustomerMessage(message, action, callback) {
  var log = logger.getLogger("CustomerMessageAPI mutateCustomerMessage");
  var mutationName = action.mutationName,
      queryParams = action.queryParams,
      data = action.data,
      headers = action.headers,
      processResponse = action.processResponse;
  var messageId = message.messageId;
  var apiConfig = createPublicAPIRequest("put", "messages/".concat(messageId, "/").concat(mutationName), _objectSpread({
    access_key: message.accessKey
  }, queryParams), data, headers);
  log.debug(apiConfig);
  axios(apiConfig).then(function (response) {
    var message;

    if (processResponse) {
      message = processResponse(response.data);
    } else {
      message = response.data;
    }

    callback(message);
  }).catch(function (error) {
    handleAPIFailure(error, "CustomerMessageAPI mutateCustomerMessage ".concat(mutationName));
    callback({
      hasError: true
    });
  });
};

export var acceptExpertAnswer = function acceptExpertAnswer(message, hasAccepted, callback) {
  var ACCEPT_ACTION = {
    mutationName: "accept",
    data: {
      accepted: hasAccepted
    },
    processResponse: function processResponse() {
      var newMessage = _objectSpread({}, message);

      if (!hasAccepted) {
        newMessage.custConfirmation = false;
        newMessage.accepted = false;
        newMessage.acceptedDate = null;
      } else {
        newMessage.accepted = true;
        newMessage.acceptedDate = new Date().getTime();
      }

      return newMessage;
    }
  };
  mutateCustomerMessage(message, ACCEPT_ACTION, callback);
};
export var submitSuggestedAnswerFeedback = function submitSuggestedAnswerFeedback(message, selectedDialogueId, callback) {
  var requestBody = {
    status: "rejected"
  };

  if (selectedDialogueId) {
    requestBody.status = "accepted";
    requestBody.dialogueId = selectedDialogueId;
  }

  var SA_FEEDBACK_ACTION = {
    mutationName: "feedback",
    data: requestBody
  };
  mutateCustomerMessage(message, SA_FEEDBACK_ACTION, callback);
};
/**
 * Submit the CSAT score back the Platform
 *
 * @param {object} message
 * @param {int} score
 * @param {function} callback
 */

export var submitMessageScore = function submitMessageScore(message, score, callback) {
  var SCORE_ACTION = {
    mutationName: "vote",
    data: {
      score: score
    },
    processResponse: function processResponse() {
      return _objectSpread({}, message, {
        customerScore: score
      });
    }
  };
  mutateCustomerMessage(message, SCORE_ACTION, callback);
};
/**
 * Submit the customer Testimonial back to the Platform
 *
 * @param {object} message
 * @param {string} testimonial
 * @param {function} callback
 */

export var submitMessageTestimonial = function submitMessageTestimonial(message, testimonial, callback) {
  var TESTIMONIAL_ACTION = {
    mutationName: "testimonial",
    data: {
      testimonial: testimonial
    },
    processResponse: function processResponse() {
      return _objectSpread({}, message, {
        custTestimonial: testimonial
      });
    }
  };
  mutateCustomerMessage(message, TESTIMONIAL_ACTION, callback);
};
/**
 * Users can add dialogues to the conversation
 *
 * @param {object} message
 * @param {object} customer
 * @param {string} response
 * @param {string} accessKey
 */

export var createDialogue = function createDialogue(message, customer, response, callback) {
  var name = customer.name;
  var accessKey = message.accessKey,
      messageId = message.messageId;
  var data = {
    body: response,
    customerName: name
  };
  var apiConfig = createPublicAPIRequest("post", "messages/".concat(messageId, "/reply"), {
    access_key: accessKey
  }, data); //Ajax call URL, payload, config

  axios(apiConfig).then(function (response) {
    callback(response.data);
  }).catch(function (error) {
    handleAPIFailure(error, "CustomerMessageAPI createDialogue");
    callback({
      hasError: true
    });
  });
};
export var reportCustomerMessage = function reportCustomerMessage(message, callback) {
  var REPORT_ACTION = {
    mutationName: "report",
    data: {
      callMethod: "REPORT"
    },
    processResponse: function processResponse() {
      return _objectSpread({}, message, {
        footerState: MESSAGE_STATE_REPORTED
      });
    }
  };
  mutateCustomerMessage(message, REPORT_ACTION, callback);
};
export var escalateCustomerMessage = function escalateCustomerMessage(message, callback) {
  var ESCALATE_ACTION = {
    mutationName: "escalate",
    data: {
      callMethod: "ESCALATE"
    },
    processResponse: function processResponse() {
      return _objectSpread({}, message, {
        footerState: MESSAGE_STATE_CLOSED
      });
    }
  };
  mutateCustomerMessage(message, ESCALATE_ACTION, callback);
};